import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { forwardRef } from 'react';

import { tss } from 'tss-react/mui';

import { env } from '@/env';

import { Or2Card } from '@/components/Surface/Or2Card';
import { Or2Image } from '@/components/image/Or2Image';

import { Or2Link } from '@/components/navigation/Or2Link';

import govhubAvatar from '../../../public/images/govhub-avatar.png';

interface Props {
  groupReferenceName: string;
}

const MAIN_AVATAR_SIZE = 60;

const useStyles = tss.create(() => {
  return {
    header: {
      paddingBottom: 0,
    },
    authorName: {
      fontWeight: 600,
    },
    mainAvatar: {
      width: MAIN_AVATAR_SIZE,
      height: MAIN_AVATAR_SIZE,
    },
  };
});

export const IntroPost = forwardRef<HTMLDivElement, Props>(
  ({ groupReferenceName }, ref) => {
    const { classes } = useStyles();
    return (
      <Or2Card ref={ref}>
        <CardHeader
          className={classes.header}
          avatar={
            <Or2Image
              src={govhubAvatar}
              alt="GovernorHub Support"
              className={classes.mainAvatar}
            />
          }
          title={
            <span className={classes.authorName}>The GovernorHub Team</span>
          }
        />
        <CardContent>
          <Typography component="div">
            <p>
              Welcome to GovernorHub. We try hard to make GovernorHub as easy
              and obvious to use as possible so feel free to click about and see
              what you can find. If you have any problems and want to get in
              touch with us then click on the little message icon in the bottom
              righthand corner of the screen. We love talking to people so
              don&apos;t be shy at getting in touch.
            </p>
            <p>
              This Noticeboard area is a way to easily email the other people in
              your {groupReferenceName} without having to keep track of all
              their email addresses. Just type in the box above and press
              &quot;Send&quot; and we&apos;ll send it to them in an email. You
              can also comment on people&apos;s posts and we&apos;ll email them
              your comment but that won&apos;t go to all the governors - just
              the person who posted and anyone else who has commented on the
              same message.
            </p>
            <p>
              There&apos;s plenty to find though so look about and don&apos;t
              forget to check out the{' '}
              <Or2Link href={env.NEXT_PUBLIC_HELP_URL}>Help section</Or2Link>.
            </p>
            <p>
              Thanks and happy GovernorHubbing!
              <br />
              The GovernorHub Team
            </p>
          </Typography>
        </CardContent>
      </Or2Card>
    );
  },
);

IntroPost.displayName = 'IntroPost';
